export enum UserRole {
  Guest = "Guest",
  Customer = "Customer",
  Admin = "Admin",
}
